import { render, staticRenderFns } from "./FluxoCobranca.vue?vue&type=template&id=a13ad384&scoped=true"
import script from "./FluxoCobranca.vue?vue&type=script&lang=js"
export * from "./FluxoCobranca.vue?vue&type=script&lang=js"
import style0 from "./FluxoCobranca.vue?vue&type=style&index=0&id=a13ad384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13ad384",
  null
  
)

export default component.exports